import React from 'react';
import { Link } from 'react-router-dom';
import { NavbarStyles } from './style';

function Navbar({ navItems, collapsed }) {
  return (
    <NavbarStyles aria-expanded={!collapsed}>
      {navItems.map(navItem => (
        <Link
          className="nav-link"
          to={navItem.link}
          aria-selected={navItem.selected}
          key={navItem.title}
        >
          <navItem.icon className="nav-icon" />
          <div className="nav-title">
            <div>{navItem.title}</div>
          </div>
        </Link>
      ))}
    </NavbarStyles>
  );
}

export default Navbar;
